import { object, string } from "yup";
import { SHORT_FIELD_MESSAGE, REQUIRED_FIELD_MESSAGE, INVALID_FIELD_MESSAGE } from "../../../../Shared";

export const validationSchema = object({
  firstName:  string()
              .min(2, SHORT_FIELD_MESSAGE(2))
              .required(REQUIRED_FIELD_MESSAGE),
  lastName:   string()
              .min(2, SHORT_FIELD_MESSAGE(2))
              .required(REQUIRED_FIELD_MESSAGE),
  email:      string()
              .required(REQUIRED_FIELD_MESSAGE)
              .email(INVALID_FIELD_MESSAGE("email address")),
  password:   string()
              .required(REQUIRED_FIELD_MESSAGE),
});

